import { observer } from 'mobx-react';
import styles from './UsersDetails.module.scss';

const UsersDetails = ({ row, columns }) => {  
  const leftColumns = columns.slice(0, columns.length / 2);
  const rightColumns = columns.slice(leftColumns.length);

  return (
    <div className={styles.content}>
      <div>
        {leftColumns.map(item => (
          <div key={item.dataColumn} className={styles.wrapper}>
            <div className={styles.label}>{item.title}</div>
            <div>{row[item.dataColumn]}</div>
          </div>
        ))}
      </div>
      <div>
        {rightColumns.map(item => ( 
          <div key={item.dataColumn} className={styles.wrapper}>
            <div className={styles.label}>{item.title}</div>
            <div>{row[item.dataColumn]}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default observer(UsersDetails);
